export default __webpack_public_path__ + "static/media/assigned.c9349008.png";